import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./dashboard-view-profile.scss";
import BackButton from "src/components/BackButton";
import Header from "src/components/Header";
import useAuth from "src/hooks/selectors/useAuth";
import Resume from "src/components/resume/Resume";
import { useParseBackUrl } from "src/hooks/useBackUrl";
import NoSubscriptionMiddleware from "src/components/middlewares/NoSubscriptionMiddleware";

export default function ViewProfileView() {
	const { id } = useParams() as any;
	const navigate = useNavigate();
	const auth = useAuth();
	const backUrl = useParseBackUrl();

	if (auth.type === "company" && !auth.has_subscription) {
		return <NoSubscriptionMiddleware />;
	}

	return (
		<Header hideLogo className="dashboard-view-profile">
			<BackButton
				to={backUrl || undefined}
				onClick={!backUrl ? () => navigate(-1) : undefined}
			/>
			<div className="flex flex-col gap-8">
				<Resume {...{ id }} />
			</div>
		</Header>
	);
}
